{
  "projects": [
    {
      "id": "gospel-of-ruin",
      "name": "Gospel of Ruin",
      "shortname": "Gospel of Ruin",
      "img": "project-gospel-of-ruin",
      "fa_icon": "<i class='fa-solid fa-xl fa-gamepad'></i>",
      "brief": "A tactical roguelike game made with Unity over two and a half months for a university project.",
      "description": "A tactical roguelike game developed over roughly two and a half months for a university project using <a href='https://unity.com/'>Unity Engine</a>, taking inspiration from Slay the Spire, Darkest Dungeon, and Dispatch. The random modifiers drawn for our game <em>Medieval</em> and <em>Horror</em>, after discarding the <em>Run'n'Gun</em> genre.<br><br><span class=\"fw-bold\">Lore:</span> Barcelona has fallen under a demonic siege and its streets are overrun by the Black Plague, a daemonic host of swarms and vile creature sent by Beelzebub. As the returned Sant Jordi, you lead a party of knights and survivors across the ruined city to end the Lord of Flies plot.<br><br><span class=\"fw-bold\">Gameplay:</span> The whole run unfolds within the pages of an illustrated chronicle: you traverse a hand-drawn map of besieged Barcelona, resolve narrative events through choices with lasting consequences, and fight demons in turn-based combat where action points are scarce and enemy intents can be anticipated. Relics gathered along the way are stored in the Reliquary, empowering the party throughout the run.<br><br>The game was developed by a five-person team, with myself acting as the project's producer and lead programmer, as well as leading the design of the combat and a number of other systems.",
      "state": [
        "live"
      ],
      "tags": [
        "csharp",
        "unity"
      ],
      "repositories": [
        "https://sarkamist.itch.io/gospel-of-ruin"
      ],
      "slideshow": [
        { "img": "gospel-of-ruin-01", "caption": "The game's main menu, watched over by a hooded statue to set the Gothic religious tone." },
        { "img": "gospel-of-ruin-02", "caption": "The hand-drawn map of besieged Barcelona. The demonic breach glows over the fallen districts." },
        { "img": "gospel-of-ruin-03", "caption": "Turn-based combat against demonic vermin, with action points, enemy intents, and each Knight's skill page at the bottom." },
        { "img": "gospel-of-ruin-04", "caption": "A narrative event unfolding within the chronicle, presenting the Knights with a grim choice." },
        { "img": "gospel-of-ruin-05", "caption": "Some choices carry dire consequences..." }
      ]
    },
    {
      "id": "the-last-gork",
      "name": "The Last Gork",
      "shortname": "The Last Gork",
      "img": "project-the-last-gork",
      "fa_icon": "<i class='fa-solid fa-xl fa-gamepad'></i>",
      "brief": "A top-down shooter game prototype made for a 48-hour Luathon at my university.",
      "description": "A quick top-down shooter made for a 48-hour Luathon/Game Jam at my university. The code was to be implemented in Lua using <a href='https://www.love2d.org/'>LÖVE 2D</a> engine and we had to use two out of three random themes that were generated: <em>Evolve</em>, <em>Darkness</em>, and <em>Containment</em>. The themes chosen by our teme were <em>Evolve</em> (slimes adapt to damage) and <em>Containment</em> (slimes have to be contained and can't escape).<br><br><span class=\"fw-bold\">Lore:</span> You are the last warrior of the Gork, an alien tribe known for being fierce warriors who protect Earth from the greatest threats. Your mission is to protect the world by containing the radioactivity of a damaged nuclear plant and kill a sum of radioactive monsters that are trying to escape the nuclear plant.<br><br>These monsters have demonstrated a huge adaptability capacity and every time they evolve they become more resistant to the Gork's arsenal.<br><br><span class=\"fw-bold\">Gameplay:</span> The Last Gork is a top-down game where you fight monsters with different kinds of weapons; the creatures will evolve, becoming more resistant to your attacks, and you will have to swap your weapons to adapt. They will also become more resistant each round. When you hurt them, you push them back a little, allowing you to gain space!<br><br><ul><li><span class=\"fw-bold\">Shotgun:</span> A weapon with a lot of damage, multishot, but with cooldown and middle range.</li><li><span class=\"fw-bold\">Handgun:</span> Medium damage, high range and fast cooldown.</li><li><span class=\"fw-bold\">Knife:</span> Short range with medium damage and short range. It deals damage in an area, that is, it does not only damage one monster but also everyone within range.</li></ul>",
      "state": [
        "prototype"
      ],
      "tags": [
        "lua",
        "love",
        "rxi-classic"
      ],
      "repositories": [
        "https://sarkamist.itch.io/the-last-gork"
      ],
      "slideshow": [
        { "img": "the-last-gork-01", "caption": "A very simple main menu." },
        { "img": "the-last-gork-02", "caption": "New game started, as we are using the knife, it shows the green overlay for damage area." },
        { "img": "the-last-gork-03", "caption": "Shooting with the handugn, the crosshair is gray as the weapon is now in cooldown." },
        { "img": "the-last-gork-04", "caption": "The shotgun's crosshair shows the range limit and bullets trajectory." },
        { "img": "the-last-gork-05", "caption": "Round #2 started and the enemies have adapted, they are now very resistant to the handgun! Time to switch weapons." }
      ]
    },
    {
      "id": "alchematch",
      "name": "Alchematch",
      "shortname": "Alchematch",
      "img": "project-alchematch",
      "fa_icon": "<i class='fa-solid fa-xl fa-gamepad'></i>",
      "brief": "A classic memory pair game built using Lua and the LÖVE 2D engine.",
      "description": "A classic memory pair game built using Lua and the <a href='https://www.love2d.org/'>LÖVE 2D</a> engine, featuring an object-oriented architecture for clean, modular design. Players flip cards to find matching pairs while the game tracks progress and performance.<br><br>Annoying flies buzz across the screen and block clicks, interrupting the player's flow and adding an extra layer of challenge.<br><br>The scoring system, which is based on moves and time since the last pair match, does tie in with a locally stored leaderboard system.",
      "state": [
        "live"
      ],
      "tags": [
        "lua",
        "love",
        "rxi-classic"
      ],
      "repositories": [
        "https://sarkamist.itch.io/alchematch"
      ],
      "slideshow": [
        { "img": "alchematch-01", "caption": "Main menu allowing you to either play a new game, consult the locally-stored leaderboard, or exit." },
        { "img": "alchematch-02", "caption": "A new game, showing the full screen, with a fly that just appeared to disrupt the player." },
        { "img": "alchematch-03", "caption": "Only one pair left to finish the victory and compute the final score. The fly must die before we are able to click the card behind." },
        { "img": "alchematch-04", "caption": "Victory screen, allowing to input your name to store into the local leaderboard." },
        { "img": "alchematch-05", "caption": "The leaderboard, showing the locally-stored .CSV file values." }
      ]
    },
    {
      "id": "last-bastion",
      "name": "Last Bastion",
      "shortname": "Last Bastion",
      "fa_icon": "<i class='fa-solid fa-xl fa-gamepad'></i>",
      "img": "project-last-bastion",
      "brief": "A game prototype made for a 3rd trimester subject on my first year of university.",
      "description": "A game prototype made for the Creation and Development Project I subject on my first year of university. The build submissions showing the development progress, as well as the source code, are available within the Github repository.<br><br>The game is a mix of the Tower Defense and Survivors-like subgenres. You take control a lone tower at the centre of the map that is besieged by different kinds of enemies. You can purchase upgrades to enhance the tower defenses and damage capabilities. The game continues undefinitely round after round, with enemies getting stronger until your inevitable demise.",
      "state": [
        "prototype"
      ],
      "tags": [
        "csharp",
        "unity"
      ],
      "repositories": [
        "https://github.com/sarkamist/Last-Bastion-Project"
      ],
      "slideshow": [
        { "img": "last-bastion-01", "caption": "Very simple menu screen for starting new games and changing a few settings." },
        { "img": "last-bastion-02", "caption": "New game just started, showing the randomized starting shop options and bastion's health." },
        { "img": "last-bastion-03", "caption": "Round #5 on a different camera angle, being besieged by various creatures. Also shows the whole HUD." }
      ]
    },
    {
      "id": "lightbound",
      "name": "Lightbound",
      "shortname": "Lightbound",
      "fa_icon": "<i class='fa-solid fa-xl fa-gamepad'></i>",
      "img": "project-lightbound",
      "brief": "A game prototype made for a 48-hour Game Jam at my university.",
      "description": "A game prototype made for a 48-hour Game Jam at my university. The game had to be implemented with C#, <a href='https://www.sfml-dev.org/'>SFML</a> media library, and <a href='https://github.com/sirdx/Candle.NET'>Candle.NET</a> lighting library. Three themes were chosen from a random theme generator: <em>Dark & Light</em>, <em>Running out of Space</em>, <em>Running out of Time</em>. All three themes were used for the prototype.<br><br>The game is rather simple. You control a lightbeam that moves towards your cursor, while the little demon's starting and final positions are shown. Your goal is to keep shining light onto the little demon as he walks through a randomly generated path collecting items. Your lightbeam lasts for a determine amount of time and you must also search for potions hidden in the darkness to refill your time. You can consume the potions by holding click on them.<br><br>Furthermore, enemy moths appear attracted by the lightbeam. They will circle around it, causing the light to drain faster. You can kill the moths by clicking on them thrice.",
      "state": [
        "prototype"
      ],
      "tags": [
        "csharp",
        "sfml",
        "candle-net"
      ],
      "repositories": [
        "https://sarkamist.itch.io/lightbound",
        "https://github.com/sarkamist/Lightbound"
      ],
      "slideshow": [
        { "img": "lightbound-01", "caption": "Starting menu screen, providing the game instructions." },
        { "img": "lightbound-02", "caption": "Beginning of a new game, showing the lightbeam following the little demon and the timer." },
        { "img": "lightbound-03", "caption": "A moth appeared and the little demon has received some damage, as shown on the bottom of the screen." }
      ]
    },
    {
      "id": "pfwotr-srk-homebrew",
      "name": "Homebrew Mod for Pathfinder: Wrath of the Righteous ",
      "shortname": "PF:WotR Homebrew Mod",
      "fa_icon": "<i class='fa-solid fa-xl fa-puzzle-piece'></i>",
      "img": "project-pf-wotr-srk-homebrew",
      "brief": "A mod made with Harmony to add some features for my own playthroughs.",
      "description": "A mod for <a href='https://wrath.owlcat.games/'>Pathfinder: Wrath of the Righteous</a> made with <a href='https://harmony.pardeike.net/'>Harmony</a> library for patching the game at runtime.<br><br>The scope of the mod was to add some bits of homebrew content for my own playthroughs of the game, but it has been expanded to provide tailored background to each of the available companions in order to provide them some unique features to compete the game's mercenary character system.<br><br>Many additional and complementary features have been added in the process of designing the custom backgrounds, such as archetype changes, new feats, new spells, and more.",
      "state": [
        "wip"
      ],
      "tags": [
        "csharp",
        "harmony",
        "unity"
      ],
      "slideshow": [
        { "img": "pf-wotr-srk-homebrew-01", "caption": "Leader of the Pack character background feature for natural weapons and Persuasion builds." },
        { "img": "pf-wotr-srk-homebrew-02", "caption": "Knight Errant companion background for Seelah, focused on defensive fighting, shields, and swords." },
        { "img": "pf-wotr-srk-homebrew-03", "caption": "Knight Errant background benefits applying in combat as Seelah is fighting defensively." },
        { "img": "pf-wotr-srk-homebrew-04", "caption": "Highborn Daredevil companion background for Camellia, focused on rapiers and crossbows while making Dexterity more useful for her." },
        { "img": "pf-wotr-srk-homebrew-05", "caption": "Camellia attacking with her Cold Iron Rapier, and using her Dexterity modifier due to her Highborn Daredevil background." },
        { "img": "pf-wotr-srk-homebrew-06", "caption": "Underground Scavenger companion background for both Lann and Wenduag, focused on bows and throwing axes while buffing Perception skill ranks." },
        { "img": "pf-wotr-srk-homebrew-07", "caption": "Martyrized Orphan companion background for Ember, focused on touch attack rolls and fire spells." },
        { "img": "pf-wotr-srk-homebrew-08", "caption": "Ember's Pyrebolt, a unique spell-like ability granted by her background. Grows in power with Religion ranks." }
      ]
    },
    {
      "id": "fvtt-tongues",
      "name": "Tongues Mod for Foundry VTT",
      "shortname": "FVTT Tongues Mod",
      "fa_icon": "<i class='fa-solid fa-xl fa-puzzle-piece'></i>",
      "img": "project-fvtt-tongues",
      "brief": "A module developed to handle character and NPC languages on Foundry VTT.",
      "description": "This module has been developed for <a href='https://foundryvtt.com/'>Foundry Virtual Tabletop</a> to facilitate the management of both character and NPC fantasy languages in an immersive manner for my own TTRPG campaigns. The concept draws inspiration from World of Warcraft's cross-faction in-game translator.<br><br>The module appends a new field to Foundry's chat box detailing all the configured languages that the selected character is able to speak, or alternatively shows all configured languages to the GM. Should a chat message be sent in character with a language other than Common selected in the chat box, the text will be parsed and scrambled according to the configured vocabulary journal entry for the chosen language.<br><br>Characters and NPCs will see a green icon next to the scrambled messages of languages they are able to speak, meaning they can understand it. Clicking on the icon will show the original text sent. The GM is able to access the original text for any language.",
      "state": [
        "live"
      ],
      "tags": [
        "js",
        "fvtt",
        "jquery"
      ],
      "slideshow": [
        { "img": "fvtt-tongues-01", "caption": "A quick vocabulary configuration for Elven language, just providing some words for the scrambling." },
        { "img": "fvtt-tongues-02", "caption": "Yishi speaks in Elven and the text gets scrambled, except for the words she surrounded with dollar signs." },
        { "img": "fvtt-tongues-03", "caption": "Iossif is unable to speak Elven and does not understand Yishi's ramblings, thus he cannot see the original text." }
      ]
    },
    {
      "id": "pf2-quickref",
      "name": "Pathfinder 2e Quick Reference",
      "shortname": "PF2e Quick Ref",
      "fa_icon": "<i class='i-custom fa-xl i-pathfinder'></i>",
      "img": "project-pf2e-quickref",
      "brief": "A Pathfinder 2nd Edition interactive reference sheet, made for quick lookup of the rules.",
      "description": "A Pathfinder 2nd Edition quick reference sheet, made for quick lookup of various rules featured across different documents. Rules are distributed in icons with a small reference text across thematic categories. Clicking on a button opens that specific rule description blob and you can access other relevant rulings via the highlighted inner references within the description.<br><br>It may also contain homebrew rules and changes I've might have introduced at my table for my player's reference.",
      "state": [
        "live"
      ],
      "tags": [
        "html",
        "css",
        "js",
        "fontawesome",
        "jquery",
        "jqueryui",
        "showdown"
      ],
      "url": "./projects/pf2-quick-reference/index.html",
      "repositories": [
        "https://github.com/sarkamist/sarkamist.github.io/tree/master/src/projects/pf2-quick-reference"
      ]
    },
    {
      "id": "dnd-quickref",
      "name": "D&D 5e Quick Reference",
      "shortname": "5e Quick Ref",
      "fa_icon": "<i class='fa-brands fa-xl fa-d-and-d'></i>",
      "img": "project-dnd-quickref",
      "brief": "A Dungeons & Dragons 5th Edition interactive reference sheet.",
      "description": "A Dungeons & Dragons 5th Edition quick reference sheet, made for quick lookup of various rules featured across different documents. Rules are distributed in icons with a small reference text across thematic categories. Clicking on a button opens that specific rule description blob and you can access other relevant rulings via the highlighted inner references within the description.<br><br>It may also contain homebrew rules and changes I've might have introduced at my table for my player's reference.",
      "state": [
        "live"
      ],
      "tags": [
        "html",
        "css",
        "js",
        "fontawesome",
        "jquery",
        "jqueryui",
        "showdown"
      ],
      "url": "./projects/5e-quick-reference/index.html",
      "repositories": [
        "https://github.com/sarkamist/sarkamist.github.io/tree/master/src/projects/5e-quick-reference"
      ]
    },
    {
      "id": "wfrp-quickref",
      "name": "WFRP 4e Quick Reference",
      "shortname": "WFRP 4e Quick Ref",
      "fa_icon": "<i class='i-custom fa-xl i-wfrp'></i>",
      "img": "project-wfrp-4e-quickref",
      "brief": "A Warhammer Fantasy Roleplay 4th Edition interactive reference sheet.",
      "description": "A Warhammer Fantasy Roleplay 4th Edition quick reference sheet, made for quick lookup of various rules featured across different documents. Rules are distributed in icons with a small reference text across thematic categories. Clicking on a button opens that specific rule description blob and you can access other relevant rulings via the highlighted inner references within the description.<br><br>It may also contain homebrew rules and changes I've might have introduced at my table for my player's reference.",
      "state": [
        "beta"
      ],
      "tags": [
        "html",
        "css",
        "js",
        "fontawesome",
        "jquery",
        "jqueryui",
        "showdown"
      ],
      "url": "./projects/wfrp-4e-quick-reference/index.html",
      "repositories": [
        "https://github.com/sarkamist/sarkamist.github.io/tree/master/src/projects/wfrp-4e-quick-reference"
      ]
    },
    {
      "id": "zh-quickref",
      "name": "Zweihänder Quick Reference",
      "shortname": "Zweihänder Quick Ref",
      "fa_icon": "<i class='i-custom fa-xl i-zweihander'></i>",
      "img": "project-zweihander-quickref",
      "brief": "A Zweihänder Grim & Perilous RPG interactive reference sheet.",
      "description": "A Zweihänder Grim & Perilous RPG quick reference sheet, made for quick lookup of various rules featured across different documents. Rules are distributed in icons with a small reference text across thematic categories. Clicking on a button opens that specific rule description blob and you can access other relevant rulings via the highlighted inner references within the description.<br><br>It may also contain homebrew rules and changes I've might have introduced at my table for my player's reference.",
      "state": [
        "wip",
        "discontinued"
      ],
      "tags": [
        "html",
        "css",
        "js",
        "fontawesome",
        "jquery",
        "jqueryui",
        "showdown"
      ],
      "url": "./projects/zweihander-quick-reference/index.html",
      "repositories": [
        "https://github.com/sarkamist/sarkamist.github.io/tree/master/src/projects/zweihander-quick-reference"
      ]
    },
    {
      "id": "sarkamist-github-io",
      "name": "About this site",
      "description": "A simple web site project made to showcase various projects from my personal portfolio.<br><br>A configuration file allows for each project details to be set, including release status, technology stack, and external links. The script reads from this file and configures each project's page accordingly.<br><br>The site is bundled with <a href='https://parceljs.org/'>PARCEL</a> and uploaded to Github Pages.",
      "state": [
        "live"
      ],
      "tags": [
        "html",
        "css",
        "js",
        "bootstrap",
        "fontawesome",
        "nodejs",
        "parcel",
        "sass",
        "underscore"
      ]
    }
  ],
  "statuses": {
    "wip": {
      "name": "<span style='filter: drop-shadow(0 0 2px #000);'>Work in Progress</span>",
      "background": "repeating-linear-gradient(45deg, #708090, #708090 10px, #4b5563 10px, #4b5563 20px)",
      "font_color": "#fff",
      "fa_icon": "<i style='filter: drop-shadow(0 0 2px #000);' class='fas fa-xl fa-wrench'></i>"
    },
    "prototype": {
      "name": "<span style='filter: drop-shadow(0 0 2px #000);'>Prototype</span>",
      "background": "repeating-linear-gradient(45deg, #f5c542, #f5c542 10px, #9c7c1a 10px, #9c7c1a 20px)",
      "font_color": "#fff",
      "fa_icon": "<i style='filter: drop-shadow(0 0 2px #000);' class='fas fa-xl fa-pen-ruler'></i>"
    },
    "alpha": {
      "name": "<span style='filter: drop-shadow(0 0 2px #000);'>Alpha Release</span>",
      "background": "repeating-linear-gradient(45deg, #9370DB, #9370DB 10px, #9932CC 10px, #9932CC 20px)",
      "font_color": "#fff",
      "fa_icon": "<i style='filter: drop-shadow(0 0 2px #000);' class='fas fa-xl fa-cogs'></i>"
    },
    "beta": {
      "name": "<span style='filter: drop-shadow(0 0 2px #000);'>Beta Release</span>",
      "background": "repeating-linear-gradient(45deg, #3366cc, #3366cc 10px, #5171b3 10px, #5171b3 20px)",
      "font_color": "#fff",
      "fa_icon": "<i style='filter: drop-shadow(0 0 2px #000);' class='fas fa-xl fa-flask'></i>"
    },
    "live": {
      "name": "<span style='filter: drop-shadow(0 0 2px #000);'>Live Release</span>",
      "background": "repeating-linear-gradient(45deg, #009900, #009900 10px, #1a801a 10px, #1a801a 20px)",
      "font_color": "#fff",
      "fa_icon": "<i style='filter: drop-shadow(0 0 2px #000);' class='fas fa-xl fa-check-circle'></i>"
    },
    "discontinued": {
      "name": "Discontinued",
      "color": "#660000",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-solid fa-xl fa-exclamation-triangle'></i>"
    }
  },
  "technologies": {
    "html": {
      "name": "HTML",
      "color": "#fd7e14",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-brands fa-html5'></i>"
    },
    "candle-net": {
      "name": "Candle.NET",
      "background": "linear-gradient(90deg, #cc130a 30%, #fa8d01 70%)",
      "font_color": "#fff",
      "fa_icon": "<i class='i-custom i-candle-net'></i>",
      "url": "https://github.com/sirdx/Candle.NET"
    },
    "css": {
      "name": "CSS",
      "color": "#17a2b8",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-brands fa-css3-alt'></i>"
    },
    "csharp": {
      "name": "C#",
      "background": "linear-gradient(90deg, #7851a9 30%, #230068 70%)",
      "font_color": "#fff"
    },
    "bootstrap": {
      "name": "Bootstrap",
      "color": "#6f42c1",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-brands fa-bootstrap'></i>",
      "url": "https://getbootstrap.com/"
    },
    "fontawesome": {
      "name": "Font Awesome",
      "color": "#1971c2",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-brands fa-font-awesome'></i>",
      "url": "https://fontawesome.com"
    },
    "fvtt": {
      "name": "Foundry VTT",
      "color": "#ff601e",
      "font_color": "#000",
      "fa_icon": "<i class='i-custom i-fvtt'></i>",
      "url": "https://foundryvtt.com/"
    },
    "harmony": {
      "name": "Harmony",
      "background": "linear-gradient(135deg, #40c0ff 50%, #50e000 50%)",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-solid fa-gear'></i>",
      "url": "https://harmony.pardeike.net/"
    },
    "parcel": {
      "name": "<span class='b-txt parcel' data-text='PARCEL'>PARCEL</span>",
      "background": "linear-gradient(90deg, #4f29bc, #1d4ed8)",
      "font_color": "#000",
      "fa_icon": "<i style='color: #e7b47d;' class='fa-solid fa-box-open'></i>",
      "url": "https://parceljs.org/"
    },
    "js": {
      "name": "Javascript",
      "color": "#ffc107",
      "font_color": "#212529",
      "fa_icon": "<i class='fa-brands fa-js'></i>"
    },
    "jquery": {
      "name": "jQuery",
      "color": "#0769ad",
      "font_color": "#fff",
      "fa_icon": "<i class='i-custom i-jquery'></i>",
      "url": "https://jquery.com/"
    },
    "jqueryui": {
      "name": "jQuery UI",
      "color": "#b24926",
      "font_color": "#fff",
      "fa_icon": "<i class='i-custom i-jquery'></i>",
      "url": "https://jqueryui.com/"
    },
    "lua": {
      "name": "Lua",
      "color": "#e9e9e9",
      "outline": "0.125em dashed #c0c0c0",
      "font_color": "#000080",
      "fa_icon": "<i class='i-custom i-lua'></i>",
      "url": "https://www.lua.org/"
    },
    "love": {
      "name": "LÖVE",
      "background": "linear-gradient(135deg, #E6457B 50%, #25AAE1 50%)",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-solid fa-heart'></i>",
      "url": "https://love2d.org/"
    },
    "nodejs": {
      "name": "Node.js",
      "color": "#417e38",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-brands fa-node-js'></i>",
      "url": "https://nodejs.org"
    },
    "rxi-classic": {
      "name": "<span style='color:#dcdcdc'>rxi/</span>classic",
      "background": "#ff4433",
      "font_color": "#fff",
      "fa_icon": "<i class='i-custom i-rxi'></i>",
      "url": "https://github.com/rxi/classic"
    },
    "sass": {
      "name": "Sass",
      "color": "#cf649a",
      "font_color": "#fff",
      "fa_icon": "<i class='fa-brands fa-sass'></i>",
      "url": "https://sass-lang.com/"
    },
    "sfml": {
      "name": "SFML",
      "background": "linear-gradient(90deg, #90cf3d 30%, #75b028 70%)",
      "font_color": "#fff",
      "fa_icon": "<i class='i-custom i-sfml'></i>",
      "url": "https://www.sfml-dev.org/"
    },
    "showdown": {
      "name": "<span class='b-txt sdb'>S</span><span class='b-txt sdb'>h</span><span class='b-txt sdb'>o</span><span class='b-txt sdb'>w</span><span style='color: #bdb35e'><span class='b-txt sdb'>d</span><span class='b-txt sdb'>o</span><span class='b-txt sdb'>w</span><span class='b-txt sdb'>n</span></span>",
      "color": "#757575",
      "font_color": "#23252d",
      "fa_icon": "<i class='fa-brands fa-markdown'></i>",
      "url": "https://github.com/showdownjs/showdown"
    },
    "underscore": {
      "name": "<span style='border-bottom: 4px solid #3ca2df;'>Under</span><span style='border-bottom: 4px solid #a7cce2;'>score.js</span>",
      "color": "#111",
      "font_color": "#a7cce2",
      "url": "https://underscorejs.org/"
    },
    "unity": {
      "name": "Unity",
      "color": "#000000",
      "font_color": "#ffffff",
      "fa_icon": "<i class='fa-brands fa-unity'></i>",
      "url": "https://unity.com"
    }
  }
}
